export const ClaudeConnectorTypeDecorator = {
  url() {
    return `signup-hubspot/integrations`;
  },
  query() {
    return {
      integration: 'claude-connector'
    };
  }
};